import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from 'rxjs';

import { Advertiser } from '../../../../../core/models/advertiser';
import { Agency } from '../../../../../core/models/agency';
import { AgencyDao } from '../../../../../core/services/dao/agencyDao';

@Component({
  selector: 'app-new-agency',
  templateUrl: './new-agency.component.html',
  styleUrls: ['./new-agency.component.scss']
})
export class NewAgencyComponent implements OnInit, OnDestroy {
  public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public zipMask = [/\d/, /\d/, /\d/, /\d/, /\d/];

  public loading = true;

  public newAgency = false;
  agency: Agency;
  public advertisers: any[];

  // advertisers list
  dataSource: any;
  displayedColumns = ['name', 'edit'];

  public data: Agency = {
    name: '',
    advertisers: [],
    street: '',
    street2: '',
    city: '',
    state: '',
    zip: '',
    phone: ''
  } as Agency;

  private subs: Array<Subscription> = [];

  constructor(
    private agencyDao: AgencyDao,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {
    this.loading = true;
  }

  ngOnInit() {
    if (this.route.snapshot.params.agencyId) {
      this.agency = this.route.snapshot.data.portal[1];
      this.data = this.agency;

      this.agency.advertisers.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        if (a.name === b.name) {
          return 0;
        }
      });
      this.dataSource = new MatTableDataSource<Advertiser>(this.agency.advertisers);
    } else {
      this.newAgency = true;
    }

    this.loading = false;
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  editAdv(advertiserId: string) {
    this.router.navigate(['manage/admin/advertisers/advertiser', advertiserId, 'edit', this.data.id]);
  }

  goBack() {
    this.location.back();
  }

  saveAgency() {
    this.loading = true;
    if (!this.newAgency) {
      // update
      let sub = this.agencyDao.update(this.data).subscribe(
        res => {
          this.agency = res as Agency;
          this.subs.push(
            this.agencyDao.loadById(this.agency.id).subscribe(res => {
              this.agency = res;
              this.data = this.agency;
              this.loading = false;
            })
          );
        },
        err => {
          console.error(err);
          this.loading = false;
        }
      );
      this.subs.push(sub);
    } else {
      //create
    //   let sub = this.agencyDao.createAgency(this.data).subscribe(
    //     res => {
    //       this.agency = res as Agency;
    //       this.newAgency = false;
    //       this.subs.push(
    //         this.agencyDao.loadById(this.agency.id).subscribe(res => {
    //           this.agency = res;
    //           this.data = this.agency;
    //           this.loading = false;
    //         })
    //       );
    //     },
    //     err => {
    //       console.error(err);
    //       this.loading = false;
    //     }
    //   );
    //   this.subs.push(sub);
    }
  }

  cancelCreate() {
    this.loading = true;
    this.router.navigate(['manage/admin/agencies']);
  }

  disableSubmit(form) {
    return form.form.invalid || !form.form.dirty;
  }
}
